export const environment = {
  production: false,
  apiUrl: 'https://advofinapitest-e4ffasaeb6hkgshs.westeurope-01.azurewebsites.net/api/',
  apiKey: '',
  environment: 'staging',
  themesCSSUrl: 'https://spa-admin.advofin.at',
  themeSettingsUrl: 'https://spa-api.advofin.at/style-staging.json',
  contractsApiUrl: 'https://spa-api.advofin.at/contracts-staging.json',
  downloadsApiUrl: 'https://spa-api.advofin.at/project-downloads-staging.json',
  trackingUrl: 'https://cdn.matomo.cloud/advofin.matomo.cloud/container_oVu587SK_staging_c659d9a4a43ecf058346f9cf.js',
  spaUrl: 'https://staging-spa.advofin.at',
  defaultAppTitle: 'AdvoFin Prozessfinanzierungs AG - Registrierung',
  defaultAppLogo: 'assets/images/advofin-logo.svg',
  projectSettingsURL: 'https://spa-api.advofin.at/project-details-staging.json'
};
